import React, { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";
import { adminMe, adminLogin, adminLogout } from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(undefined); // undefined=loading, null=guest, obj=auth

  const check = useCallback(async () => {
    try {
      const me = await adminMe();
      setUser(me);
    } catch {
      // 401 on guest visits is expected; other errors surface via UI actions.
      setUser(null);
    }
  }, []);

  useEffect(() => { check(); }, [check]);

  const login = useCallback(async (email, password) => {
    const data = await adminLogin(email, password);
    setUser(data);
    check();
    return data;
  }, [check]);

  const logout = useCallback(async () => {
    try { await adminLogout(); } catch { /* server errors on logout are non-fatal */ }
    setUser(null);
  }, []);

  const value = useMemo(() => ({ user, login, logout, refresh: check }), [user, login, logout, check]);

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);

export const hasRole = (user, ...roles) => user && roles.includes(user.role);
